import {
  Activity, Building2, CircleUserRound, Cloud, Coins, DollarSign, LayoutDashboard, Mail, Megaphone, ScrollText,
  ShieldCheck, Sparkles, Tags, UserCog, UserPlus,
} from "lucide-react";

// أصناف Tailwind مكتوبة صراحةً لتفادي purge (كل تبويب بلون مميّز).
export const PLATFORM_TABS = [
  { key: "overview",  icon: LayoutDashboard, iconCls: "text-sky-500",     activeCls: "text-sky-600" },
  { key: "companies", icon: Building2,       iconCls: "text-emerald-500", activeCls: "text-emerald-600", countKey: "companies" },
  { key: "requests",  icon: UserPlus,        iconCls: "text-rose-500",    activeCls: "text-rose-600",    countKey: "requests", alert: true },
  { key: "features",  icon: Sparkles,        iconCls: "text-fuchsia-500", activeCls: "text-fuchsia-600" },
  { key: "notify",    icon: Megaphone,       iconCls: "text-orange-400",  activeCls: "text-orange-500" },
  { key: "tokens",    icon: Coins,           iconCls: "text-amber-500",   activeCls: "text-amber-600" },
  { key: "faceCost",  icon: Cloud,           iconCls: "text-orange-500",  activeCls: "text-orange-600" },
  { key: "pricing",   icon: Tags,            iconCls: "text-indigo-500",  activeCls: "text-indigo-600" },
  { key: "revenue",   icon: DollarSign,      iconCls: "text-lime-600",    activeCls: "text-lime-700" },
  { key: "system",    icon: Activity,        iconCls: "text-red-500",     activeCls: "text-red-600",     countKey: "health", alert: true },
  { key: "email",     icon: Mail,            iconCls: "text-cyan-500",    activeCls: "text-cyan-600" },
  { key: "staff",     icon: UserCog,         iconCls: "text-violet-500",  activeCls: "text-violet-600" },
  { key: "avatars",   icon: CircleUserRound, iconCls: "text-slate-500",   activeCls: "text-slate-700" },
  { key: "audit",     icon: ShieldCheck,     iconCls: "text-teal-500",    activeCls: "text-teal-600" },
  { key: "logs",      icon: ScrollText,      iconCls: "text-pink-500",    activeCls: "text-pink-600",    countKey: "logs" },
];

export const TAB_KEYS = PLATFORM_TABS.map((tab) => tab.key);
